import { sanitizeGamePreferences, type GamePreferences } from "../gameplay/ProgressManager";

const percent = (value: number): string => String(Math.round(value * 100));


export function settingsControlsMarkup(
    preferences: GamePreferences
): string {
    return `
    <div class="settings-grid">

      <fieldset class="settings-section">
        <legend>Audio</legend>

        <label>
          <span>Kelantangan Utama</span>
          <output data-output="masterVolume">
            ${percent(preferences.masterVolume)}%
          </output>
          <input
            data-setting="masterVolume"
            type="range"
            min="0"
            max="1"
            step="0.05"
            value="${preferences.masterVolume}"
          >
        </label>

        <label>
          <span>Ambien Hutan</span>
          <output data-output="ambienceVolume">
            ${percent(preferences.ambienceVolume)}%
          </output>
          <input
            data-setting="ambienceVolume"
            type="range"
            min="0"
            max="1"
            step="0.05"
            value="${preferences.ambienceVolume}"
          >
        </label>

        <label>
          <span>Kesan Bunyi</span>
          <output data-output="sfxVolume">
            ${percent(preferences.sfxVolume)}%
          </output>
          <input
            data-setting="sfxVolume"
            type="range"
            min="0"
            max="1"
            step="0.05"
            value="${preferences.sfxVolume}"
          >
        </label>

        <label class="toggle">
          <input
            data-setting="muted"
            type="checkbox"
            ${preferences.muted ? "checked" : ""}
          >
          <span>Senyapkan semua bunyi</span>
        </label>
      </fieldset>

      <fieldset class="settings-section">
        <legend>Grafik</legend>

        <label>
          <span>Kualiti Grafik</span>
          <select data-setting="quality">
            <option value="low">Rendah</option>
            <option value="medium">Sederhana</option>
            <option value="high">Tinggi</option>
          </select>
        </label>
      </fieldset>

      <fieldset class="settings-section">
        <legend>Kawalan</legend>

        <label>
          <span>Sensitiviti Tetikus</span>
          <output data-output="mouseSensitivity">
            ${preferences.mouseSensitivity.toFixed(4)}
          </output>
          <input
            data-setting="mouseSensitivity"
            type="range"
            min="0.0008"
            max="0.006"
            step="0.0001"
            value="${preferences.mouseSensitivity}"
          >
        </label>

        <label>
          <span>Sensitiviti Sentuhan</span>
          <output data-output="touchSensitivity">
            ${preferences.touchSensitivity.toFixed(4)}
          </output>
          <input
            data-setting="touchSensitivity"
            type="range"
            min="0.0015"
            max="0.01"
            step="0.0001"
            value="${preferences.touchSensitivity}"
          >
        </label>

        <label class="toggle">
          <input
            data-setting="invertY"
            type="checkbox"
            ${preferences.invertY ? "checked" : ""}
          >
          <span>Songsangkan paksi Y</span>
        </label>
      </fieldset>

    </div>
  `;
}


export function readSettingsControls(root: ParentNode, fallback: GamePreferences): GamePreferences {
  const value = (key: string): HTMLInputElement | HTMLSelectElement | null => root.querySelector(`[data-setting="${key}"]`);
  return sanitizeGamePreferences({
    quality: value("quality")?.value as GamePreferences["quality"] ?? fallback.quality,
    masterVolume: Number(value("masterVolume")?.value ?? fallback.masterVolume),
    ambienceVolume: Number(value("ambienceVolume")?.value ?? fallback.ambienceVolume),
    sfxVolume: Number(value("sfxVolume")?.value ?? fallback.sfxVolume),
    muted: Boolean((value("muted") as HTMLInputElement | null)?.checked),
    mouseSensitivity: Number(value("mouseSensitivity")?.value ?? fallback.mouseSensitivity),
    touchSensitivity: Number(value("touchSensitivity")?.value ?? fallback.touchSensitivity),
    invertY: Boolean((value("invertY") as HTMLInputElement | null)?.checked),
  });
}

export function initializeSettingsControls(root: ParentNode, preferences: GamePreferences, onChange?: (preferences: GamePreferences) => void): () => GamePreferences {
  const quality = root.querySelector<HTMLSelectElement>('[data-setting="quality"]');
  if (quality) quality.value = preferences.quality;
  const update = (): GamePreferences => {
    const next = readSettingsControls(root, preferences);
    for (const key of ["masterVolume", "ambienceVolume", "sfxVolume"] as const) {
      const output = root.querySelector<HTMLOutputElement>(`[data-output="${key}"]`); if (output) output.value = `${Math.round(next[key] * 100)}%`;
    }
    for (const key of ["mouseSensitivity", "touchSensitivity"] as const) {
      const output = root.querySelector<HTMLOutputElement>(`[data-output="${key}"]`); if (output) output.value = next[key].toFixed(4);
    }
    onChange?.(next);
    return next;
  };
  root.querySelectorAll<HTMLElement>("[data-setting]").forEach((control) => { control.addEventListener("input", update); control.addEventListener("change", update); });
  return update;
}
